import moment from 'moment';
import { ConfiguracoesService } from '../../../Configuracoes/configuracoes.service';
import { IConfiguracoesGet } from '../../../Configuracoes/models/configuracoes.model';
import { IConfiguracoesEscala, getConfiguracoesEscalaPadrao } from '../models/escala.configuracoes.model';

function getValorConfiguracao(configuracoes: IConfiguracoesGet[]): string | number | boolean | undefined {
    return configuracoes[0]?.valor;
}

function valorConfiguracaoAtivo(valor: string | number | boolean | undefined): boolean {
    return valor === true || valor === 'true' || valor === 1 || valor === '1';
}

export function montarDataFechamentoCalendario(
    configuracoesEscala: IConfiguracoesEscala,
    dataBase: moment.Moment = moment()
): string {
    if (!configuracoesEscala.USA_SLA_CALENDARIO) {
        return '';
    }

    const diaFechamento = parseInt(configuracoesEscala.FECHAMENTO_CALENDARIO, 10);
    if (isNaN(diaFechamento) || diaFechamento <= 0) {
        return '';
    }

    let mes = dataBase.month() + 1;
    let ano = dataBase.year();

    if (configuracoesEscala.CALENDARIO_FECHA_PROXIMO_MES) {
        mes += 1;
        if (mes === 13) {
            mes = 1;
            ano += 1;
        }
    }

    const ultimoDiaMes = moment({ year: ano, month: mes - 1 }).daysInMonth();
    const dia = diaFechamento > ultimoDiaMes ? ultimoDiaMes : diaFechamento;

    return moment({ year: ano, month: mes - 1, date: dia }).format('YYYY-MM-DD');
}

export async function carregarConfiguracoesEscala(service: ConfiguracoesService): Promise<IConfiguracoesEscala> {
    return Promise.all([
        service.getConfiguracoes({ id: 'USA_SLA_CALENDARIO', estabelecimento: '' }).catch(() => [] as IConfiguracoesGet[]),
        service.getConfiguracoes({ id: 'FECHAMENTO_CALENDARIO', estabelecimento: '' }).catch(() => [] as IConfiguracoesGet[]),
        service.getConfiguracoes({ id: 'CALENDARIO_FECHA_PROXIMO_MES', estabelecimento: '' }).catch(() => [] as IConfiguracoesGet[]),
    ]).then(([usaSlaConfiguracao, fechamentoCalendarioConfiguracao, calendarioFechaProximoMesConfiguracao]) => {
        const configuracoesEscala = getConfiguracoesEscalaPadrao();
        const usaSla = getValorConfiguracao(usaSlaConfiguracao);
        const fechamentoCalendario = getValorConfiguracao(fechamentoCalendarioConfiguracao);
        const calendarioFechaProximoMes = getValorConfiguracao(calendarioFechaProximoMesConfiguracao);

        return {
            ...configuracoesEscala,
            USA_SLA_CALENDARIO: valorConfiguracaoAtivo(usaSla),
            FECHAMENTO_CALENDARIO: typeof fechamentoCalendario === 'string' ? fechamentoCalendario : '',
            CALENDARIO_FECHA_PROXIMO_MES: valorConfiguracaoAtivo(calendarioFechaProximoMes),
        };
    });
}

export function formatarDataFechamentoCalendario(configuracoesEscala: IConfiguracoesEscala): string {
    const dataFechamentoCalendario = montarDataFechamentoCalendario(configuracoesEscala);

    return dataFechamentoCalendario
        ? moment(dataFechamentoCalendario, 'YYYY-MM-DD').format('DD/MM/YYYY')
        : '';
}
